import { useState } from "react";
import { BookOpen } from "lucide-react";

export const DESIGNS = [
  { id: "classic", name: "Classic", bg: "#F6F1E7", fg: "#1C1917", accent: "#9A7B4F", font: "Georgia, 'Times New Roman', serif", tagline: "Available now" },
  { id: "bold", name: "Bold", bg: "#0A0A0A", fg: "#FFFFFF", accent: "#FACC15", font: "'Outfit', sans-serif", tagline: "The new must-read" },
  { id: "minimal", name: "Minimal", bg: "#FFFFFF", fg: "#18181B", accent: "#A1A1AA", font: "'DM Sans', sans-serif", tagline: "Now in print" },
  { id: "vibrant", name: "Vibrant", bg: "#0F3D3E", fg: "#F8FAF9", accent: "#F59E0B", font: "'Outfit', sans-serif", tagline: "Meet the author" },
];

const ASPECTS = { retractable_banner: "2 / 4.6", hanging_banner: "2 / 1", bookmarks: "1 / 3.2", flyers: "17 / 22" };

const Cover = ({ url, accent, className }) => {
  const [failed, setFailed] = useState(false);
  if (failed || !url) {
    return (
      <div className={`${className} flex items-center justify-center border border-dashed rounded-[2px]`} style={{ borderColor: accent }}>
        <BookOpen size={16} style={{ color: accent }} />
      </div>
    );
  }
  return <img src={url} alt="cover" onError={() => setFailed(true)} className={`${className} object-cover shadow-md rounded-[2px]`} />;
};

export const MarketingPreview = ({ productId, design, coverUrl, title, authorName, mini = false }) => {
  const landscape = productId === "hanging_banner";
  const slim = productId === "bookmarks";
  const t = mini
    ? { tag: "4px", title: "6px", author: "5px" }
    : { tag: slim ? "8px" : "11px", title: slim ? "12px" : "19px", author: slim ? "9px" : "13px" };
  return (
    <div
      style={{ aspectRatio: ASPECTS[productId] || "17 / 22", background: design.bg, color: design.fg, fontFamily: design.font, padding: "7%", border: "1px solid rgba(0,0,0,0.08)" }}
      className={`w-full rounded-sm overflow-hidden flex ${landscape ? "flex-row items-center gap-[6%] text-left" : "flex-col items-center justify-center text-center gap-[5%]"}`}
    >
      <Cover url={coverUrl} accent={design.accent}
        className={landscape ? "h-[86%] aspect-[2/3] shrink-0" : slim ? "w-[70%] aspect-[2/3]" : "w-[50%] aspect-[2/3]"} />
      <div className="min-w-0 flex-1">
        <p style={{ fontSize: t.tag, color: design.accent, letterSpacing: "0.2em", textTransform: "uppercase", fontWeight: 600 }}>{design.tagline}</p>
        <p style={{ fontSize: t.title, fontWeight: 700, lineHeight: 1.15 }} className="line-clamp-2 break-words">{title || "Your Book Title"}</p>
        <p style={{ fontSize: t.author, opacity: 0.75, marginTop: "2%" }} className="truncate">by {authorName || "Author Name"}</p>
      </div>
    </div>
  );
};
